import { Nullable, OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { StaffType } from '../Types/StaffType'
import { EnumStaffRole } from '../Enum'
import { StaffDto } from '../Types/StaffDto'
import { StaffApiAdapter } from '../Adapters/StaffApiAdapter'
import { User } from '../../../admin/vue/classes/User'

export default class Staff {
    public id: Nullable<number> = null
    public userId: Nullable<number> = null
    public active = true
    public role: Nullable<EnumStaffRole> = null

    public user?: User

    public constructor(data?: StaffType) {
        if (data) {
            Object.assign(this, { ...data })
        }
    }

    public static getUserWithRoleFromStaff(staffs: Staff[], role: EnumStaffRole): User[] {
        return staffs.reduce((users: User[], staff: Staff) => {
            if (staff.user && staff.role === role) {
                users.push(staff.user)
            }
            return users
        }, [])
    }

    public static convertDtoToStaffList(staffs?: OneOrMore<StaffDto>): Staff[] {
        if (staffs) {
            return Array.isArray(staffs)
                ? staffs.map(new StaffApiAdapter().createClass)
                : [new StaffApiAdapter().createClass(staffs)]
        }
        return []
    }

    public toDto(): StaffDto {
        return {
            personnel_id: this.id,
            user_id: this.userId,
            active: this.active,
            emplacement: this.role,
            _ref_user: this.user ? this.user.toDto() : undefined,
        }
    }
}
